export const messageInfo = {
  "title":'标题',
  "url": '站内信外链',
  "pushSwitch":"APP推送开关",
  "content":"内容",
  "createTime":"发送时间",
};
